import React from "react";

const ModalWindow = ({ show, children }) => {
  const showHideClassName = show
    ? "flags-modal display-block"
    : "flags-modal display-none";

  return (
    <div className={showHideClassName}>
      <section className="flags-modal-main">{children}</section>
    </div>
  );
};

export default ModalWindow;
